<template>
  <Popup
    v-bind="{
      open,
    }"
    :alignment="alignment"
    menuPaddingClass=""
    menuBorderClass="border-gray-200"
    menuWidth="20rem"
    @change="open = $event"
  >
    <template slot="anchor">
      <button
        class="btn btn-naked p-1.5 border-none relative"
        aria-haspopup="true"
        :aria-expanded="open"
        @click="open = !open"
      >
        <Bell class="w-6 h-6" />
        <span class="sr-only">Notifications</span>
        <div
          v-if="hasNotifications"
          class="absolute top-1.5 right-1.5 rounded-full h-1 w-1 bg-enterprise-primary"
        ></div>
      </button>
    </template>

    <template slot="content">
      <div v-if="contentReady" class="divide-y border-gray-200">
        <header class="px-4 py-2">
          <p class="text-sm font-bold">
            {{ page.title }} <span>({{ notifications.length }})</span>
          </p>
        </header>

        <div v-if="hasNotifications" class="max-h-80 overflow-y-auto">
          <ul class="divide-y">
            <NotificationItem
              v-for="notification in notifications"
              :key="notification.id"
              :logo="logo"
              :notification="notification"
            />
          </ul>
        </div>
        <div
          v-if="!hasNotifications"
          class="text-center p-14 flex flex-col gap-y-4 items-center"
        >
          <BellFilled class="w-8 h-8 text-enterprise-primary" />
          <p>{{ page.no_notifications.title }}</p>
          <p class="text-xs">{{ page.no_notifications.description }}</p>
        </div>
      </div>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup'
import Bell from '@/assets/svg/icons/outline/bell.svg?inline'
import BellFilled from '@/assets/svg/icons/bell.svg?inline'
import NotificationItem from '@/components/notifications/NotificationItem.vue'
import { getPages } from '@/mixins/content'

export default {
  components: {
    Popup,
    Bell,
    BellFilled,
    NotificationItem,
  },

  mixins: [getPages(['notifications'], true)],

  props: {
    logo: { type: Object, default: {} },
    alignment: { type: String, default: 'right' },
  },

  data: () => ({
    open: false,
  }),

  computed: {
    notifications() {
      return this.contentReady ? this.page.notifications : []
    },

    hasNotifications() {
      return this.notifications.length > 0
    },
  },
}
</script>
